import { FC } from 'react'

import { ISvgClass } from '../interface'

const IssueInvoiceIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.0"
      width="24px"
      height="24px"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="inherit"
        stroke="none"
      >
        <path d="M2002 4317 l-492 -492 0 -258 0 -257 -108 0 -107 0 -450 -450 -450 -450 -197 0 -198 0 0 -900 0 -900 755 0 755 0 0 -150 0 -150 1805 0 1805 0 0 2250 0 2250 -1313 0 -1312 0 -493 -493z m2818 -1757 l0 -1950 -1505 0 -1505 0 0 138 0 137 450 450 450 450 0 -138 0 -137 905 0 905 0 0 150 0 150 -892 0 -893 0 242 243 242 242 -55 80 c-31 44 -74 99 -97 123 -63 65 -169 132 -266 166 -80 29 -96 31 -216 30 -116 0 -139 -3 -210 -28 -114 -39 -167 -75 -374 -250 -101 -86 -185 -156 -187 -156 -2 0 -4 304 -4 675 l0 675 450 0 450 0 0 450 0 450 1055 0 1055 0 0 -1950z m-2410 1540 l0 -190 -192 0 -193 0 190 190 c104 105 191 190 192 190 2 0 3 -85 3 -190z m-900 -1596 l0 -506 -47 -42 -47 -43 20 -24 c51 -65 168 -199 173 -199 3 1 175 145 381 322 418 357 448 378 574 386 78 5 173 -20 229 -60 l29 -21 -703 -703 -704 -704 -557 0 -558 0 0 600 0 600 113 0 112 0 450 450 450 450 42 0 43 0 0 -506z" />
        <path d="M3610 4048 l0 -163 -65 -34 c-160 -82 -257 -277 -227 -455 34 -205 186 -353 390 -378 106 -14 156 -38 182 -87 25 -51 25 -91 0 -141 -23 -45 -80 -80 -130 -80 -50 0 -107 35 -130 80 -11 21 -20 46 -20 55 0 13 -22 15 -150 15 -171 0 -160 7 -139 -92 27 -125 115 -243 224 -299 l65 -34 0 -162 0 -163 150 0 150 0 0 163 0 162 65 34 c160 82 257 277 227 455 -34 205 -186 353 -390 378 -106 14 -156 38 -182 87 -25 51 -25 91 0 141 23 45 80 80 130 80 50 0 107 -35 130 -80 11 -21 20 -46 20 -55 0 -13 22 -15 150 -15 171 0 160 -7 139 92 -27 125 -115 243 -224 299 l-65 34 0 163 0 162 -150 0 -150 0 0 -162z" />
        <path d="M2710 1060 l0 -150 905 0 905 0 0 150 0 150 -905 0 -905 0 0 -150z" />
      </g>
    </svg>
  )
}

export default IssueInvoiceIcon
